export default function findUserAction(userAction) {
    switch (userAction) {
        case 1:
            return 'Create';
            break;
        case 2:
            return 'Update';
            break;
        case 3:
            return 'Delete';
            break;
        default:
            return '';
            break;
    }
}


// WEBPACK FOOTER //
// ./src/core/utils/findUserAction.js